import styled from 'styled-components';
import { InfoButtonStyled } from '../InfoButtonStyled';
export const InfoButtonStyledOV = styled(InfoButtonStyled)`
    .InfoButton {
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg data-name='0079_N73InformationXSmall_Solid' xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cdefs%3E%3CclipPath id='il75mg8o8a'%3E%3Cpath data-name='0079_N73InformationXSmall_Solid' style='fill:none' d='M0 0h16v16H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Groupe 1223' style='clip-path:url(%23il75mg8o8a)'%3E%3Cpath data-name='Tracé 706' d='M9.202 4.469H6.797V2.594h2.405zm0 8.5H6.797V6.047h2.405zM.437 8.001A7.562 7.562 0 1 0 7.999.438 7.562 7.562 0 0 0 .437 8.001z'/%3E%3C/g%3E%3C/svg%3E");
        }
    }
`;
